const messages_br = {
  //Header
  'header': 'Mensagem em PT-BR',
};

export default messages_br